import { IColumn, Stack, Text } from '@fluentui/react';
import { UserGroupRowItem } from '.';
import { UserGroupModalView } from '../view';

export type ColumnStylesProps = {
  onRenderColumnStack: string;
};

export const onRenderItems = (styles: ColumnStylesProps) => {
  const renderItemColumn = (
    item: UserGroupRowItem | undefined,
    _index: number | undefined,
    column: IColumn | undefined
  ) => {
    if (item) {
      const fieldContent = item[
        column?.fieldName as keyof UserGroupRowItem
      ] ;
      switch (column?.key) {
        case 'action':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              <UserGroupModalView userGroup={item} />
            </Stack>
          );
        default:
          return (
            <Stack
              verticalAlign="center"
              className={styles.onRenderColumnStack}
            >
              <Text>{fieldContent?.toString()}</Text>
            </Stack>
          );
      }
    }
  };
  return renderItemColumn;
};
